export default "__VITE_ASSET__7b7b6e50__"